module.exports = __webpack_public_path__ + "static/media/match_whole_word_only.7b232370.png";